import React, { useEffect, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import { useStyles } from './styles';

export const DragAndDropArea: React.FC = () => {
  const styles = useStyles();
  const [files, setFiles] = useState<any[]>([]);
  const { getRootProps, getInputProps } = useDropzone({
    accept: {
      'image/*': [],
    },
    onDrop: (acceptedFiles) => {
      setFiles(acceptedFiles.map((file) => Object.assign(file, {
        preview: URL.createObjectURL(file),
      })));
    },
  });

  useEffect(() => {
    return () => files.forEach((file) => URL.revokeObjectURL(file.preview));
  }, [files]);

  return (
    <div {...getRootProps({ className: 'dropzone' })} className={styles.dragAndDropWrapper}>
      <input {...getInputProps()} />
      <span>Upload gallery picture 2320×424 px (JPEG format) </span>
    </div>
  );
};
